module.exports = __webpack_public_path__ + "img/zantac_360_maximum_strength.75c06a08.jpeg";